<template>
  <v-container>
    <v-dialog v-model="dialog" persistent scrollable max-width="90%">
      <v-card v-if="dadosGuia">
        <v-card-title class="pa-0">
          <v-col class="text-end px-0 py-0">
            <v-btn icon dark @click="close(false)">
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col class="text-center pt-0 pb-3" cols="12">
            <h1>Dados da guia</h1>
            <p class="mb-0">{{tipoGuia}} – Guia Reduzida</p>
          </v-col>
          <v-col class="text-right pb-4 pt-0" cols="6">
            <span class="card-title-form-guia">Nº guia prestador: </span>
            <span style="font-size:16px">{{dadosGuia.cabecalhoGuia.numeroGuiaPrestador}}</span>
          </v-col>

          <v-col class="text-left pb-4 pt-0" cols="6">
            <span class="card-title-form-guia">Total Geral (R$): </span>
            <span style="font-size:16px" v-if="tipoGuia!='Consulta'">{{dadosGuia.valorTotal.valorTotalGeral | formatPrice }}</span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-row class="ma-0">
            <v-col class="px-2 py-2" cols="3" v-if="!['Consulta'].includes(tipoGuia)">
              <b class="texts">Data da autorização</b>
              <p class="texts mb-0">{{dadosGuia.dadosAutorizacao.dataAutorizacao | formatDate}}</p>
            </v-col>
            <v-col class="px-2 py-2" cols="3" v-if="!['Consulta'].includes(tipoGuia)">
              <b class="texts">Senha</b>
              <p class="texts mb-0">{{dadosGuia.dadosAutorizacao.senha }}</p>
            </v-col>
            <v-col class="px-2 py-2" cols="3" v-if="!['Consulta'].includes(tipoGuia)">
              <b class="texts">Validade da senha</b>
              <p class="texts mb-0">{{dadosGuia.dadosAutorizacao.dataValidadeSenha | formatDate}}</p>
            </v-col>
            <v-col class="px-2 py-2" cols="3">
              <b class="texts">Nº da guia na operadora</b>
              <p class="texts mb-0">{{dadosGuia.dadosAutorizacao.numeroGuiaOperadora }}</p>
            </v-col>
            <v-col class="px-2 py-2" cols="3">
              <b class="texts">Nº da carteira</b>
              <p class="texts mb-0">{{dadosGuia.dadosBeneficiario.numeroCarteira }}</p>
            </v-col>
            <v-col class="px-2 py-2" cols="3">
              <b class="texts">Nome beneficiário</b>
              <p class="texts mb-0">{{ dadosGuia.dadosBeneficiario.nomeBeneficiario }}</p>
            </v-col>
            <v-col class="px-2 py-2" cols="3">
              <b class="texts">Cartão Nacional de Saúde</b>
              <p class="texts mb-0">{{ dadosGuia.dadosBeneficiario.numeroCNS }}</p>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <!-- CONSELHO PROFISSIONAL   -->
            <v-col v-if="['SP-SADT', 'Consulta'].includes(tipoGuia)" class="px-2 py-2" cols="3">
              <b class="texts">Profissional {{tipoGuia == 'SP-SADT' ?'solicitante' :'executante'}}</b>
              <p class="texts mb-0">{{ tipoGuia == 'SP-SADT'? dadosGuia.profissionalSolicitante.nomeProfissional : dadosGuia.profissionalExecutante.nomeProfissional }}</p>
            </v-col>
            <v-col v-if="['SP-SADT'].includes(tipoGuia)" class="px-2 py-2" cols="3">
              <b class="texts">Conselho profissional do solicitante</b>
              <p class="texts mb-0" v-if="dadosGuia.profissionalSolicitante">{{ getDescricaoDominio('dm_conselhoProfissional', dadosGuia.profissionalSolicitante.conselhoProfissional)}}</p>
            </v-col>
            <v-col v-if="['Consulta'].includes(tipoGuia)" class="px-2 py-2" cols="3">
              <b class="texts">Conselho profissional do Executante</b>
              <p class="texts mb-0">{{ getDescricaoDominio('dm_conselhoProfissional', dadosGuia.profissionalExecutante.conselhoProfissional)}}</p>
            </v-col>
            <v-col v-if="['SP-SADT', 'Consulta'].includes(tipoGuia)" class="px-2 py-2" cols="3">
              <b class="texts">N° do Conselho do {{tipoGuia == 'SP-SADT' ?'solicitante' :'executante'}}</b>
              <p class="texts mb-0">{{ tipoGuia == 'SP-SADT'? dadosGuia.profissionalSolicitante.numeroConselhoProfissional : dadosGuia.profissionalExecutante.numeroConselhoProfissional }}</p>
            </v-col>

            <v-col v-if="['SP-SADT', 'Consulta'].includes(tipoGuia)" class="px-2 py-2" cols="3">
              <b class="texts">Código CBO do {{tipoGuia == 'SP-SADT' ?'solicitante' :'executante'}}</b>
              <p class="texts mb-0">{{ tipoGuia == 'SP-SADT'? dadosGuia.profissionalSolicitante.CBOS : dadosGuia.profissionalExecutante.CBOS }}</p>
            </v-col>
            <!-- FINAL CONSELHO PROFISSIONAL -->
            <!-- CONTRATADO -->
            <v-col class="px-2 py-2" cols="3">
              <b class="texts">{{tiposIdentificacao[dadosGuia.contratadoExecutante.tipoCodigo]}}</b>
              <p class="texts mb-0">{{ dadosGuia.contratadoExecutante.codigo }}</p>
            </v-col>
            <v-col  v-if="['Internação', 'Honorários'].includes(tipoGuia)" class="px-2 py-2" cols="3">
              <b class="texts">Data início faturamento</b>
              <p class="texts mb-0" v-if="dadosGuia.dadosInternacao">{{dadosGuia.dadosInternacao.dataInicioFaturamento | formatDate }}</p>
            </v-col>
            <v-col  v-if="['Internação', 'Honorários'].includes(tipoGuia)" class="px-2 py-2" cols="3">
              <b class="texts">Data fim faturamento</b>
              <p class="texts mb-0" v-if="dadosGuia.dadosInternacao">{{dadosGuia.dadosInternacao.dataFinalFaturamento | formatDate }}</p>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <dataTable :dominioTiss="dominioTiss"  :headers="headersProcedimentos" :list="listProcedimentos" title="Procedimentos e Exames executados"/>
          <dataTable :dominioTiss="dominioTiss" :headers="headersOutrasDespesas" :list="listOutrasDespesas" title="Outras despesas"/>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn 
            color="primary" 
            height="30px" 
            small 
            depressed 
            @click="close()"
          >
            Fechar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import DataTable from "./DataTable"
export default {
  components: {
    DataTable
  },
  data() {
    return {
      headersProcedimentos: [
        { text: "Data", align: "date" ,value: "dataExecucao", sortable: false },
        { text: "Tabela", width: "1px" , align:"center", value: "codigoTabela", sortable: false, },
        { text: "Código do Procedimento", value: "codigoProcedimento", sortable: false },
        { text: "Seq. do item", align:"center" , value: "sequencialItem", sortable: false },
        { text: "Descrição", value: "descricaoProcedimento", sortable: false },
        { text: "Qtde.", align:"center",value: "quantidadeExecutada", sortable: false },
        { text: "Valor unitário (R$)", width: "80px" , align:"end",value: "valorUnitario", sortable: false },
        { text: "Valor total (R$)", align:"end",value: "valorTotal", sortable: false },
      ],
      headersOutrasDespesas: [
        { text: "Data", align: "date" ,value: "dataExecucao", sortable: false },
        { text: "Tabela", width: "1px" , align:"center", value: "codigoTabela", sortable: false, },
        { text: "Cód. do Procedimento", value: "codigoProcedimento", sortable: false },
        { text: "Seq. do item", align:"center" , value: "sequencialItem", sortable: false },
        { text: "Item vinc.", align:"center" , width: "1px" , value: "itemVinculado", sortable: false },
        { text: "Descrição", value: "descricaoProcedimento", sortable: false },
        { text: "Qtde.", align:"center",value: "quantidadeExecutada", sortable: false },
        { text: "Valor unitário (R$)", width: "80px" , align:"end",value: "valorUnitario", sortable: false },
        { text: "Valor total (R$)", align:"end",value: "valorTotal", sortable: false },
      ],
      listProcedimentos: [],
      listOutrasDespesas:[],

      tiposIdentificacao: {
        codigoPrestadorNaOperadora: 'Cód. na operadora do solicitante',
        CNPJ: 'CNPJ do solicitante',
        CPF: 'CPF do solicitante'
      }
    }
  },
  methods: {
    
     getDescricaoDominio(tabela, valor) {
        let dominioItem = this.dominioTiss[tabela].find(el=> el.valor==valor)
        return dominioItem? dominioItem.descricao : 'Tabela de código '+ valor
      }
  },
  watch: {
    dadosGuia(val){
      this.listProcedimentos = val.procedimentosExecutados? val.procedimentosExecutados.procedimento :[]
      this.listOutrasDespesas = val.outrasDespesas? val.outrasDespesas.despesa : []
    }
    
  },
  props: {
    close: Function,
    dadosGuia: Object,
    dialog: Boolean,
    tipoGuia:  String,
    dominioTiss: Object
  },
};
</script>

<style>
.texts {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 23px;
}

</style>